import { useTranslation } from "react-i18next";
import helpers from "../../../Utils/helpers";
import system from "../../../Constants/system";
import { VossProductGroupType } from "../../../Constants/VOSS/vossProductGroupType";

export default function CompensationVossSubscriptions({ subscriptions, onClick }) {
    const { t } = useTranslation();

    const handleProductClick = (subscription) => {
        const mainProducts = subscription.productGroups
            .filter(pg => pg.productGroupType === VossProductGroupType.Included)
            .map(pg => pg.externalId)
            .join(', ');
            
        const product = {
            product: mainProducts,
            name: subscription.tier.name,
            sourceSystem: system.Voss,
            subscriptionId: subscription.id,
            period: null,
            users: null,
            api: null
        };
        onClick(product);
    };

    return <fieldset className="col-xs-12">
        <legend>{t('compensationvosssubscriptions.header')}</legend>
        <div className="table-container">
            <table className="table table-stripe table-hover table-saas-products">
                <thead>
                    <tr>
                        <th className="text-left">{t('common.package')}</th>
                        <th className="text-left">{t('compensationvosssubscriptions.tier')}</th>
                        <th className="text-left">{t('compensationvosssubscriptions.purchasedate')}</th>
                        <th className="text-left">{t('compensationvosssubscriptions.enddate')}</th>
                    </tr>
                </thead>
                <tbody>
                    {subscriptions.map((subscription) =>
                        <tr key={subscription.id} onClick={() => handleProductClick(subscription)}>
                            <td className="text-left">{subscription.package.name}</td>
                            <td className="text-left">{subscription.tier.name}</td>
                            <td className="text-left">{helpers.formatDate(subscription.created)}</td>
                            <td className="text-left">{helpers.formatDate(subscription.bindingPeriod.endDate)}</td>
                        </tr>)
                    }
                </tbody>
            </table>
        </div>
    </fieldset>
}